export default __webpack_public_path__ + "static/media/Crow Shadow Armbands.c8994324.jpg";